// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__9c17g","Open":"SideDrawer_Open__3O93D","Close":"SideDrawer_Close__1lk1e","Logo":"SideDrawer_Logo__3tFoh"};